import React from "react";
import { usePageRootHook } from "./root-hooks";

type ContextPageRoot = ReturnType<typeof usePageRootHook>;
export const RootContext = React.createContext<ContextPageRoot | null>(null);

export function useContextPageRoot() {
  const context = React.useContext(RootContext);

  if (!context) {
    throw new Error(
      "useContextPageRoot must be used within a ContextPageRootProvider",
    );
  }

  return context;
}
